export function isSchoolScoped() {
  return window.sessionStorage.getItem('schoolScoped') === 'true'
}

export function getBoundSchoolId() {
  const value = window.sessionStorage.getItem('schoolId')
  if (value === null || value === '' || value === '0') {
    return null
  }
  const id = Number(value)
  return Number.isNaN(id) ? null : id
}

export function getBoundSchoolName() {
  return window.sessionStorage.getItem('schoolName') || ''
}

export function lockSchoolOptions(list) {
  const source = Array.isArray(list) ? list : []
  if (!isSchoolScoped()) {
    return source
  }
  const boundId = getBoundSchoolId()
  const boundName = getBoundSchoolName()
  if (boundId == null && !boundName) {
    return []
  }
  const matched = source.filter(item => {
    if (item == null) {
      return false
    }
    if (typeof item === 'string' || typeof item === 'number') {
      return String(item) === String(boundName) || Number(item) === Number(boundId)
    }
    const itemId = item.schoolId != null ? item.schoolId : item.id
    const itemName = item.schoolName || item.school_name
    return (boundId != null && Number(itemId) === Number(boundId))
      || (boundName && itemName === boundName)
  })
  if (matched.length) {
    return matched
  }
  if (boundId != null) {
    return [{ schoolId: boundId, schoolName: boundName || String(boundId) }]
  }
  return boundName ? [boundName] : []
}

export function applySchoolQuery(params) {
  if (!params || !isSchoolScoped()) {
    return params
  }
  const boundId = getBoundSchoolId()
  if (boundId != null) {
    params.schoolId = boundId
  }
  const boundName = getBoundSchoolName()
  if (boundName && Object.prototype.hasOwnProperty.call(params, 'schoolName')) {
    params.schoolName = boundName
  }
  return params
}

function shouldSkipSchoolInject(config) {
  const url = (config && config.url ? String(config.url) : '')
  if (url.indexOf('user/login') !== -1) {
    return true
  }
  if (!window.sessionStorage.getItem('token')) {
    return true
  }
  const headers = (config && config.headers) || {}
  const contentType = headers['Content-Type'] || headers['content-type'] || ''
  if (String(contentType).toLowerCase().indexOf('multipart') !== -1) {
    return true
  }
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    return true
  }
  return false
}

export function injectBoundSchool(config) {
  if (!config || !isSchoolScoped() || shouldSkipSchoolInject(config)) {
    return config
  }
  const schoolId = getBoundSchoolId()
  if (schoolId == null) {
    return config
  }
  if (!config.params) {
    config.params = {}
  }
  if (typeof config.params === 'object' && !(config.params instanceof URLSearchParams)) {
    config.params.schoolId = schoolId
  }
  if (config.data
      && typeof config.data === 'object'
      && !Array.isArray(config.data)
      && !(typeof FormData !== 'undefined' && config.data instanceof FormData)
      && !(typeof Blob !== 'undefined' && config.data instanceof Blob)) {
    config.data.schoolId = schoolId
  }
  return config
}
